import { useEffect, useRef } from 'react'

const useOutclick = (ref, handler) => {
  const handlerRef = useRef(handler)

  useEffect(() => {
    handlerRef.current = handler
  }, [handler])

  useEffect(() => {
    const listener = (event) => {
      const currentPortals = Array.from(document.querySelectorAll('.portal'))
      const isInsidePortal = currentPortals.some((portal) => portal.contains(event.target))
      if (!ref.current || ref.current.contains(event.target) || isInsidePortal) return

      handlerRef.current(event)
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref])
}

export default useOutclick